import type { Player as LordPlayer } from '@lordicon/react';
import { lazy, Suspense, useRef, useState, useEffect } from 'react';

// PRAT-154: o player traz o lottie-web (o maior pacote do app). Ele fica num
// arquivo à parte, baixado depois que a tela já apareceu.
const Player = lazy(() => import('@lordicon/react').then(m => ({ default: m.Player })));

interface LordIconProps {
  src: string;
  trigger?: 'hover' | 'click' | 'loop' | 'morph' | 'in';
  colors?: string;
  className?: string;
  size?: number;
}

export function LordIcon({ src, trigger = 'click', colors, className, size = 24 }: LordIconProps) {
  const playerRef = useRef<LordPlayer>(null);
  const [iconData, setIconData] = useState(null);

  useEffect(() => {
    // Carregar o arquivo JSON
    fetch(src)
      .then(response => response.json())
      .then(data => setIconData(data))
      .catch(() => console.error('Error loading icon data'));
  }, [src]);

  useEffect(() => {
    // Auto-play when trigger is 'in' or 'loop'
    if (iconData && (trigger === 'in' || trigger === 'loop')) {
      const timer = setTimeout(() => {
        playerRef.current?.playFromBeginning();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [iconData, trigger]);

  const handleTrigger = () => {
    if (trigger === 'click') {
      playerRef.current?.playFromBeginning();
    }
  };

  return (
    <div className={className} onClick={handleTrigger}>
      <Suspense fallback={<div style={{ width: size, height: size }} />}>
        <Player
          ref={playerRef}
          icon={iconData}
          onComplete={() => {
            if (trigger === 'loop') {
              setTimeout(() => playerRef.current?.playFromBeginning(), 1000);
            }
          }}
          colors={colors}
          size={size}
        />
      </Suspense>
    </div>
  );
}
